import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseclient';

export default function Concessao() {
  const [loading, setLoading] = useState(false);
  const [perfilAtivo, setPerfilAtivo] = useState(null);
  const [idEdicao, setIdEdicao] = useState(null);

  // Função para gerar data no formato YYYY-MM-DD sem erros de fuso horário
  const obterDataHojeISO = () => {
    // Isso garante o formato ISO ignorando a inversão de fuso do sistema
    return new Date().toLocaleDateString('sv-SE'); // O locale 'sv-SE' retorna YYYY-MM-DD
  };

  useEffect(() => {
    const checkUser = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        const { data: p } = await supabase.from('perfis').select('nome').eq('id', session.user.id).maybeSingle();
        setPerfilAtivo(p?.nome || "Responsável");
      }
    };
    checkUser();
  }, []);

  useEffect(() => {
    const dadosParaEditar = localStorage.getItem('dadosEdicao');
    if (dadosParaEditar) {
      const item = JSON.parse(dadosParaEditar);
      setIdEdicao(item.id); 

      const tentarPreencher = () => {
        const f = document.forms[0]; 
        if (f && f.beneficiario) {
          if (f.item_estoque) f.item_estoque.value = item.tipo_atendimento || "";
          if (f.beneficiario) f.beneficiario.value = item.nome_beneficiario || "";
          if (f.cpf) f.cpf.value = item.cpf || "";
          if (f.telefone) f.telefone.value = item.telefone || "";
          if (f.endereco) f.endereco.value = item.endereco || "";
          if (f.observacoes) f.observacoes.value = item.observacoes || "";
          if (f.quantidade) f.quantidade.value = item.quantidade || 1;
          // Preenche a data salva no banco ao editar
          if (f.data_concessao) f.data_concessao.value = item.data_atual || obterDataHojeISO();

          localStorage.removeItem('dadosEdicao');
        } else {
          setTimeout(tentarPreencher, 50);
        }
      };
      tentarPreencher();
    }
  }, []);

  const handleCPF = (e) => {
    let v = e.target.value.replace(/\D/g, "");
    if (v.length > 11) v = v.substring(0, 11);
    v = v.replace(/(\d{3})(\d)/, "\$1.\$2");
    v = v.replace(/(\d{3})\.(\d{3})(\d)/, "\$1.\$2.\$3");
    v = v.replace(/(\d{3})\.(\d{3})\.(\d{3})(\d)/, "\$1.\$2.\$3-\$4");
    e.target.value = v;
  };

  const handleFinalizarEImprimir = async (e) => {
    e.preventDefault();
    setLoading(true);

    const fd = new FormData(e.target);
    const dadosForm = Object.fromEntries(fd);
    const itemNome = dadosForm.item_estoque;
    const qtdSaida = parseInt(dadosForm.quantidade) || 1;

    const dataFinal = dadosForm.data_concessao || obterDataHojeISO();

    try {
      if (dadosForm.cpf && !idEdicao) {
        const { data: ultima } = await supabase
          .from('fundo_social_concessoes')
          .select('data_atual, tipo_atendimento')
          .eq('cpf', dadosForm.cpf)
          .eq('tipo_atendimento', itemNome)
          .order('data_atual', { ascending: false })
          .limit(1)
          .maybeSingle();

        if (ultima) {
          const dataUltima = new Date(ultima.data_atual + "T12:00:00");
          const dataRef = new Date(dataFinal + "T12:00:00");
          const diffDias = Math.floor((dataRef - dataUltima) / (1000 * 60 * 60 * 24));

          if (diffDias >= 0 && diffDias < 25) {
            alert(`BLOQUEIO: O beneficiário retirou ${itemNome} há apenas ${diffDias} dias desta data.`);
            setLoading(false);
            return;
          }
        }
      }

      if (!idEdicao) {
        const { data: estoqueAtual } = await supabase.from('estoque').select('saldo_atual').eq('item', itemNome).single();
        if (estoqueAtual) {
          await supabase.from('estoque').update({ saldo_atual: estoqueAtual.saldo_atual - qtdSaida }).eq('item', itemNome);
        }
      }

      const payload = {
        tipo_atendimento: itemNome,
        nome_beneficiario: dadosForm.beneficiario,
        endereco: dadosForm.endereco,
        telefone: dadosForm.telefone,
        cpf: dadosForm.cpf,
        observacoes: dadosForm.observacoes,
        quantidade: qtdSaida,
        orgao: "Fundo Social de Solidariedade",
        responsavel_atendimento: perfilAtivo,
        data_atual: dataFinal 
      };

      if (idEdicao) {
        const { error } = await supabase.from('fundo_social_concessoes').update(payload).eq('id', idEdicao);
        if (error) throw error;
      } else {
        const { error } = await supabase.from('fundo_social_concessoes').insert([payload]);
        if (error) throw error;
      }

      alert(idEdicao ? "Registro atualizado!" : "Concessão registrada!");

      setTimeout(() => {
        window.print();
        setIdEdicao(null);
        e.target.reset();
      }, 500);

    } catch (error) {
      alert("Erro ao processar: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto">
      <style dangerouslySetInnerHTML={{ __html: `
        @media print {
          aside, header, footer, button, .no-print { display: none !important; }
          body { background: white !important; margin: 0; padding: 0; }
          .print-area { display: block !important; width: 100% !important; box-shadow: none !important; border: none !important; padding: 0 !important; margin: 0 !important; }
          .input-field, input, select, textarea { border: none !important; background: transparent !important; padding: 0 !important; font-weight: bold !important; appearance: none; -webkit-appearance: none; }
          label { color: #666 !important; font-size: 10px !important; }
        }
      `}} />

      <div className="bg-white rounded-[2rem] shadow-2xl overflow-hidden border border-gray-100 print-area">
        <div className="p-6 md:p-8 border-b-2 border-gray-200">
          <div className="flex items-center justify-between mb-4">
            <img src="/brasao-mirassol.png" alt="Brasão Mirassol" className="h-20 w-auto object-contain" />
            <div className="text-center flex-1 px-4">
              <h1 className="text-lg font-black uppercase leading-tight">Prefeitura Municipal de Mirassol</h1>
              <h2 className="text-md font-bold uppercase text-blue-900">Fundo Social de Solidariedade</h2>
              <p className="text-[10px] text-gray-500 font-bold mt-1">Rua São Sebastião, 1843 - Centro - Mirassol/SP</p>
              <p className="text-[10px] text-gray-500 font-bold">(17) 3242-6934</p>
            </div>
            <img src="/logo-fundo-social-black.png" alt="Logo Fundo Social" className="h-20 w-auto object-contain" />
          </div>
          <div className="text-center mt-6 py-2 bg-gray-100 rounded-lg print:bg-transparent">
            <h3 className="text-sm font-black uppercase tracking-[0.2em]">{idEdicao ? "Edição de Registro" : "Comprovante de Concessão"}</h3>
          </div>
        </div>

        <form onSubmit={handleFinalizarEImprimir} className="p-8 space-y-8">
          <div className="grid grid-cols-4 gap-6">
            <div className="col-span-3">
              <label className="text-[10px] font-black text-gray-400 uppercase block mb-1">Tipo Beneficio</label>
              <select name="item_estoque" className="w-full p-3 bg-gray-50 rounded-xl border-none font-bold outline-none focus:ring-2 focus:ring-blue-500 transition-all appearance-none">
                <option value="Cesta Grande">Cesta Grande</option>
                <option value="Cesta Pequena">Cesta Pequena</option>
                <option value="Leite">Leite</option>
              </select>
            </div>
            <div>
              <label className="text-[10px] font-black text-gray-400 uppercase block mb-1">Quantidade</label>
              <input type="number" name="quantidade" defaultValue="1" className="w-full p-3 bg-gray-50 rounded-xl border-none font-bold outline-none focus:ring-2 focus:ring-blue-500 transition-all" />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

